/* ============================================================
   AXIS MOTORSPORTS — storefront behaviour
   Progressive enhancement only: every control degrades to a plain
   link/form submit if this script fails to load or run.
   ============================================================ */
(function () {
  'use strict';

  var body = document.body;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

  function firstFocusable(el) {
    return el ? el.querySelector(FOCUSABLE) : null;
  }

  function trapFocus(e, container) {
    if (e.key !== 'Tab' || !container) return;
    var items = container.querySelectorAll(FOCUSABLE);
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  /* ---------- Bottom sheets ----------
     Generic open/close for anything built from snippets/sheet.liquid. Triggered
     by [data-sheet-open="<id>"], so one sheet can have several triggers.

     The off-canvas drawer and search panel below predate this and keep their own
     copies of the same logic; they are working UX and were left alone rather
     than migrated as a side effect of adding filters. */
  (function sheets() {
    var sheets = document.querySelectorAll('[data-sheet]');
    if (!sheets.length) return;

    Array.prototype.forEach.call(sheets, function (el) {
      var id = el.id;
      var backdrop = document.querySelector('[data-sheet-backdrop="' + id + '"]');
      var triggers = document.querySelectorAll('[data-sheet-open="' + id + '"]');
      if (!triggers.length) return;
      var returnFocus = null;

      function onKeydown(e) {
        if (e.key === 'Escape') { close(); return; }
        trapFocus(e, el);
      }

      function open() {
        returnFocus = document.activeElement;
        el.hidden = false;
        if (backdrop) backdrop.hidden = false;
        void el.offsetWidth; /* reflow so the transition runs */
        el.classList.add('is-open');
        if (backdrop) backdrop.classList.add('is-open');
        el.setAttribute('aria-hidden', 'false');
        Array.prototype.forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', 'true'); });
        body.classList.add('no-scroll');
        /* Focus the sheet, not its first control: moving focus here is what
           screen readers need, while focusing the close button painted a focus
           ring over it the instant the sheet opened. */
        el.focus();
        document.addEventListener('keydown', onKeydown);
      }

      function close() {
        el.classList.remove('is-open');
        if (backdrop) backdrop.classList.remove('is-open');
        el.setAttribute('aria-hidden', 'true');
        Array.prototype.forEach.call(triggers, function (t) { t.setAttribute('aria-expanded', 'false'); });
        body.classList.remove('no-scroll');
        document.removeEventListener('keydown', onKeydown);
        window.setTimeout(function () {
          el.hidden = true;
          if (backdrop) backdrop.hidden = true;
        }, 280);
        if (returnFocus && returnFocus.focus) returnFocus.focus();
      }

      Array.prototype.forEach.call(triggers, function (t) { t.addEventListener('click', open); });
      if (backdrop) backdrop.addEventListener('click', close);
      Array.prototype.forEach.call(el.querySelectorAll('[data-sheet-close]'), function (b) {
        b.addEventListener('click', close);
      });
    });
  }());

  /* ---------- Facets ---------- */
  (function facets() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-facets-form]'), function (form) {
      var submit = form.querySelector('[data-facets-submit]');
      var plain = submit && submit.getAttribute('data-label-plain');

      form.addEventListener('change', function () {
        /* The button counts the CURRENT results, which stops being true the
           moment the selection changes. Drop the number rather than show a
           stale one — the real count arrives with the next page. */
        if (submit && plain) {
          submit.textContent = plain;
          plain = null;
        }
        if (form.hasAttribute('data-facets-auto')) form.submit();
      });

      /* An empty price box means "no bound", but an empty input still submits
         an empty param and Shopify treats that as a filter. Strip them. */
      form.addEventListener('submit', function () {
        Array.prototype.forEach.call(form.querySelectorAll('input[type="number"]'), function (input) {
          if (input.value === '') input.disabled = true;
        });
      });
    });
  }());

  /* ---------- Fitment sheet ---------- */
  (function fitment() {
    var form = document.querySelector('[data-fitment-form]');
    if (!form) return;
    var makeSel = form.querySelector('[data-fitment-make]');
    var modelSel = form.querySelector('[data-fitment-model]');
    var years = form.querySelectorAll('.fitsheet__year');
    if (!makeSel || !modelSel) return;

    function show(el, on) {
      el.hidden = !on;
      var input = el.querySelector('input');
      if (input) input.disabled = !on;
    }

    function syncModels() {
      var make = makeSel.value;
      var firstVisible = null;
      Array.prototype.forEach.call(modelSel.options, function (opt) {
        var match = opt.getAttribute('data-make') === make;
        opt.hidden = !match;
        opt.disabled = !match;
        if (match && !firstVisible) firstVisible = opt;
      });
      if (firstVisible && modelSel.selectedOptions[0] && modelSel.selectedOptions[0].hidden) {
        modelSel.value = firstVisible.value;
      }
      syncYears();
    }

    function syncYears() {
      var make = makeSel.value;
      var model = modelSel.value;
      var firstVisible = null;
      Array.prototype.forEach.call(years, function (row) {
        var match = row.getAttribute('data-make') === make && row.getAttribute('data-model') === model;
        show(row, match);
        if (match && !firstVisible) firstVisible = row;
      });
      /* Keep exactly one generation selected, or the form submits no target. */
      var checked = form.querySelector('.fitsheet__year:not([hidden]) input:checked');
      if (!checked && firstVisible) firstVisible.querySelector('input').checked = true;
    }

    makeSel.addEventListener('change', syncModels);
    modelSel.addEventListener('change', syncYears);
    syncModels();

    /* The chosen generation carries its destination, so navigate to it rather
       than submitting fitment_target as a query parameter nothing reads. */
    form.addEventListener('submit', function (e) {
      var picked = form.querySelector('input[name="fitment_target"]:checked');
      if (!picked || !picked.value) return;
      e.preventDefault();
      window.location.href = picked.value;
    });
  }());

  /* ---------- Off-canvas mobile drawer ---------- */
  (function drawer() {
    var el = document.querySelector('[data-drawer]');
    var backdrop = document.querySelector('[data-drawer-backdrop]');
    var openBtn = document.querySelector('[data-drawer-open]');
    if (!el || !openBtn) return;
    var returnFocus = null;

    function onKeydown(e) {
      if (e.key === 'Escape') { close(); return; }
      trapFocus(e, el);
    }

    function open() {
      returnFocus = document.activeElement;
      el.hidden = false;
      if (backdrop) backdrop.hidden = false;
      void el.offsetWidth; /* reflow so the transition runs */
      el.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      el.setAttribute('aria-hidden', 'false');
      openBtn.setAttribute('aria-expanded', 'true');
      body.classList.add('no-scroll');
      var f = firstFocusable(el);
      if (f) f.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      el.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
      openBtn.setAttribute('aria-expanded', 'false');
      body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () {
        el.hidden = true;
        if (backdrop) backdrop.hidden = true;
      }, 280);
      if (returnFocus && returnFocus.focus) returnFocus.focus();
    }

    openBtn.addEventListener('click', open);
    if (backdrop) backdrop.addEventListener('click', close);
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-close]'), function (b) {
      b.addEventListener('click', close);
    });
  }());

  /* ---------- Mobile search panel ---------- */
  (function searchPanel() {
    var el = document.querySelector('[data-search-panel]');
    var openBtn = document.querySelector('[data-search-open]');
    if (!el || !openBtn) return;

    function onKeydown(e) { if (e.key === 'Escape') close(); }

    function open() {
      el.hidden = false;
      void el.offsetWidth;
      el.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      var input = el.querySelector('input[type="search"]');
      if (input) input.focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      el.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.removeEventListener('keydown', onKeydown);
      window.setTimeout(function () { el.hidden = true; }, 240);
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    Array.prototype.forEach.call(document.querySelectorAll('[data-search-close]'), function (b) {
      b.addEventListener('click', close);
    });
  }());

  /* ---------- Predictive search (Shopify /search/suggest.json) ---------- */
  (function predictive() {
    if (!('fetch' in window)) return;

    Array.prototype.forEach.call(document.querySelectorAll('[data-predictive-search]'), function (form) {
      var input = form.querySelector('[data-predictive-input]');
      var results = form.querySelector('[data-predictive-results]');
      if (!input || !results) return;
      var timer = null;
      var controller = null;

      function hide() {
        results.hidden = true;
        form.classList.remove('is-predictive-open');
        input.setAttribute('aria-expanded', 'false');
      }

      function show() {
        results.hidden = false;
        form.classList.add('is-predictive-open');
        input.setAttribute('aria-expanded', 'true');
      }

      function escapeHtml(s) {
        return String(s).replace(/[&<>"']/g, function (c) {
          return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
      }

      function render(q, data) {
        var res = data && data.resources && data.resources.results;
        var products = (res && res.products) || [];
        if (!products.length) { hide(); return; }
        var suggestLabel = (window.AXIS_STRINGS && window.AXIS_STRINGS.productSuggestions) || 'Product suggestions';
        var html = '<ul class="predictive__list" role="listbox" aria-label="' + suggestLabel.replace(/"/g, '&quot;') + '">';
        products.forEach(function (p) {
          var img = (p.featured_image && p.featured_image.url) || p.image || '';
          html += '<li role="option"><a href="' + encodeURI(p.url) + '">';
          html += img
            ? '<span class="predictive__thumb"><img src="' + encodeURI(img) + '" alt="" width="44" height="44" loading="lazy"></span>'
            : '<span class="predictive__thumb predictive__thumb--ph"></span>';
          html += '<span class="predictive__meta"><span class="predictive__name">' + escapeHtml(p.title) + '</span>';
          if (p.vendor) html += '<span class="predictive__vendor">' + escapeHtml(p.vendor) + '</span>';
          html += '</span></a></li>';
        });
        html += '</ul>';
        html += '<a class="predictive__all" href="' + form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '">See all results for &ldquo;' + escapeHtml(q) + '&rdquo;</a>';
        results.innerHTML = html;
        show();
      }

      function run(q) {
        if (controller) controller.abort();
        controller = ('AbortController' in window) ? new AbortController() : null;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=6' +
          '&resources[options][unavailable_products]=last';
        fetch(url, controller ? { signal: controller.signal } : undefined)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) { if (data) render(q, data); })
          .catch(function () { /* leave the native form submit as the fallback */ });
      }

      input.setAttribute('role', 'combobox');
      input.setAttribute('aria-expanded', 'false');
      input.setAttribute('aria-autocomplete', 'list');

      input.addEventListener('input', function () {
        var q = input.value.trim();
        window.clearTimeout(timer);
        if (q.length < 2) { hide(); return; }
        timer = window.setTimeout(function () { run(q); }, 220);
      });

      input.addEventListener('focus', function () {
        if (input.value.trim().length >= 2 && results.innerHTML.trim()) show();
      });

      document.addEventListener('click', function (e) {
        if (!form.contains(e.target)) hide();
      });

      input.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') hide();
      });
    });
  }());

  /* ---------- AJAX cart drawer ---------- */
  (function cartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || !('fetch' in window)) return;
    var backdrop = document.querySelector('[data-cart-backdrop]');
    var inner = drawer.querySelector('[data-cart-inner]');
    var SECTION = 'cart-drawer';
    var returnFocus = null;
    var busy = false;
    var upsellFor = null;

    function onKey(e) {
      if (e.key === 'Escape') close();
      else trapFocus(e, drawer);
    }

    function open() {
      returnFocus = document.activeElement;
      if (backdrop) { backdrop.hidden = false; void backdrop.offsetWidth; backdrop.classList.add('is-open'); }
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      body.classList.add('no-scroll');
      document.addEventListener('keydown', onKey);
      var c = drawer.querySelector('[data-cart-close]');
      if (c) c.focus();
      loadUpsells();
    }

    function close() {
      drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      body.classList.remove('no-scroll');
      document.removeEventListener('keydown', onKey);
      window.setTimeout(function () { if (backdrop) backdrop.hidden = true; }, 280);
      if (returnFocus && returnFocus.focus) returnFocus.focus();
    }

    function setBusy(v) { busy = v; drawer.classList.toggle('is-busy', v); }

    function updateCount(n) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-cart-count]'), function (el) {
        el.textContent = n;
        el.classList.toggle('is-empty', n === 0);
      });
    }

    function refresh() {
      return fetch('/?section_id=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-inner]');
          if (fresh && inner) inner.innerHTML = fresh.innerHTML;
          var count = doc.querySelector('[data-cart-count]');
          updateCount(count ? (parseInt(count.textContent, 10) || 0) : 0);
          upsellFor = null;
          loadUpsells();
        });
    }

    function addToCart(formData) {
      setBusy(true);
      return fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { setBusy(false); open(); })
        .catch(function () { setBusy(false); });
    }

    function changeQty(key, qty) {
      setBusy(true);
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { if (!r.ok) throw new Error('change'); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () { setBusy(false); })
        .catch(function () { setBusy(false); });
    }

    function loadUpsells() {
      var wrap = drawer.querySelector('[data-cart-upsell]');
      var list = drawer.querySelector('[data-cart-upsell-list]');
      if (!wrap || !list) return;
      var items = drawer.querySelectorAll('[data-cart-item][data-product-id]');
      if (!items.length) { wrap.hidden = true; return; }
      var pid = items[0].getAttribute('data-product-id');
      if (!pid || pid === upsellFor) return;
      upsellFor = pid;
      var inCart = {};
      Array.prototype.forEach.call(items, function (it) { inCart[it.getAttribute('data-product-id')] = true; });
      fetch('/recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=6&intent=related')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          var products = (data && data.products) || [];
          var picks = products.filter(function (p) { return !inCart[p.id] && p.available !== false; }).slice(0, 3);
          if (!picks.length) { wrap.hidden = true; return; }
          list.innerHTML = picks.map(renderUpsell).join('');
          wrap.hidden = false;
        })
        .catch(function () { wrap.hidden = true; });
    }

    function renderUpsell(p) {
      var img = (p.featured_image) || (p.images && p.images[0]) || '';
      var vid = (p.variants && p.variants[0]) ? p.variants[0].id : '';
      return '<div class="upsell">' +
        (img
          ? '<a class="upsell__thumb" href="' + encodeURI(p.url) + '" tabindex="-1"><img src="' + encodeURI(img) + '" alt="" width="48" height="48" loading="lazy"></a>'
          : '<span class="upsell__thumb upsell__thumb--ph"></span>') +
        '<a class="upsell__name" href="' + encodeURI(p.url) + '">' + escHtml(p.title) + '</a>' +
        (vid ? '<button type="button" class="upsell__add" data-upsell-add data-variant-id="' + vid + '" aria-label="Add ' + escHtml(p.title) + ' to cart">+</button>' : '') +
        '</div>';
    }

    function escHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* product form (PDP main button + sticky bar share this form) */
    Array.prototype.forEach.call(document.querySelectorAll('form.product-form'), function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!busy) addToCart(new FormData(form));
      });
    });

    /* header cart icon opens the drawer instead of navigating */
    Array.prototype.forEach.call(document.querySelectorAll('[data-cart-toggle]'), function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        refresh().then(open);
      });
    });

    /* delegated actions inside the drawer */
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { e.preventDefault(); close(); return; }
      var qty = e.target.closest('[data-qty-change]');
      if (qty && !busy) {
        e.preventDefault();
        var key = qty.getAttribute('data-key');
        var to = parseInt(qty.getAttribute('data-to'), 10);
        if (key && !isNaN(to) && to >= 0) changeQty(key, to);
        return;
      }
      var up = e.target.closest('[data-upsell-add]');
      if (up && !busy) {
        e.preventDefault();
        var vid = up.getAttribute('data-variant-id');
        if (vid) {
          var fd = new FormData();
          fd.append('id', vid);
          fd.append('quantity', '1');
          addToCart(fd);
        }
      }
    });

    if (backdrop) backdrop.addEventListener('click', close);
  }());

  /* ---------- Sticky PDP add-to-cart ---------- */
  (function pdpSticky() {
    var sticky = document.querySelector('[data-pdp-sticky]');
    var atc = document.querySelector('form.product-form [name="add"]');
    if (!sticky || !atc || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var scrolledPast = e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', !e.isIntersecting && scrolledPast);
    }, { threshold: 0 });
    io.observe(atc);
  }());

  /* ---------- Flash-sale countdown ---------- */
  (function countdown() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-countdown]'), function (el) {
      var endStr = el.getAttribute('data-end');
      if (!endStr) return;
      var end = new Date(endStr).getTime();
      if (isNaN(end)) return;
      var h = el.querySelector('[data-cd-h]'), m = el.querySelector('[data-cd-m]'), s = el.querySelector('[data-cd-s]');
      if (!h || !m || !s) return;
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      var t = window.setInterval(tick, 1000);
      function tick() {
        var diff = Math.floor((end - Date.now()) / 1000);
        if (diff <= 0) { h.textContent = '00'; m.textContent = '00'; s.textContent = '00'; window.clearInterval(t); return; }
        h.textContent = pad(Math.floor(diff / 3600));
        m.textContent = pad(Math.floor(diff / 60) % 60);
        s.textContent = pad(diff % 60);
      }
      tick();
    });
  }());
}());

  /* ---------- Beam checkout ---------- */
  (function beamCheckout() {
    var root = document.querySelector('[data-beam-checkout]');
    if (!root) return;
    var form = root.querySelector('[data-beam-form]');
    var country = root.querySelector('[data-beam-country]');
    var shipEl = root.querySelector('[data-beam-shipping]');
    var totalEl = root.querySelector('[data-beam-total]');
    var totalLabel = root.querySelector('[data-beam-total-label]');
    var payBtn = root.querySelector('[data-beam-pay]');
    var payLabel = root.querySelector('[data-beam-pay-label]');
    var note = root.querySelector('[data-beam-note]');

    var subtotal = parseInt(root.getAttribute('data-subtotal'), 10) || 0;  /* satang */
    var serviceUrl = (root.getAttribute('data-service-url') || '').trim();
    var strings = (window.AXIS_STRINGS && window.AXIS_STRINGS.beam) || {};

    /* cart line items, rendered server-side — the service builds the draft from these */
    var cartEl = root.querySelector('[data-beam-cart]');
    var cartItems = [];
    try { cartItems = JSON.parse((cartEl && cartEl.textContent) || '[]'); } catch (e) { cartItems = []; }

    /* province: a Thai-province <select> for Thailand, a free-text box otherwise.
       A typed-in bogus province breaks Shopify's shipping-rate lookup. */
    var provinceTh = root.querySelector('[data-province-th]');
    var provinceOther = root.querySelector('[data-province-other]');
    var provinceThWrap = root.querySelector('[data-province-th-wrap]');
    function provinceValue() {
      return country.value === 'Thailand'
        ? (provinceTh ? provinceTh.value : '')
        : (provinceOther ? provinceOther.value.trim() : '');
    }
    function syncProvince() {
      var th = country.value === 'Thailand';
      if (provinceThWrap) provinceThWrap.hidden = !th;
      if (provinceTh) provinceTh.disabled = !th;
      if (provinceOther) { provinceOther.hidden = th; provinceOther.disabled = th; }
    }
    syncProvince();
    var shippingSatang = null;   /* null until computed */
    var shippingName = '';
    var rewardSatang = 0;        /* points REQUESTED, as satang — an estimate until /checkout answers */
    var rewardPoints = 0;        /* points requested */
    var couponCode = '';         /* applied coupon code ('' = none) */
    var couponSatang = 0;        /* its previewed discount — an estimate until /checkout answers */
    /* Set when /checkout answered with a total that differs from the estimate
       on screen: the customer has now SEEN the confirmed figure, and the next
       press goes to that payment link instead of posting again. Anything that
       changes the order clears it. */
    var confirmedUrl = null;

    function money(satang) {
      /* Match Shopify's money filter for this store — "1,234.00 ฿" (symbol
         after), so the JS-rendered shipping and total sit consistently beside
         the Liquid-rendered line prices. */
      var baht = satang / 100;
      return baht.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ฿';
    }
    function fill(str, key, value) {
      return (str || '').replace(new RegExp('\\{\\{\\s*' + key + '\\s*\\}\\}', 'g'), value);
    }

    /* What the BROWSER thinks the order costs. Only ever an estimate: the
       backend recomputes shipping from Shopify and the points discount from
       Odoo, and its amountSatang is the figure actually charged. */
    function estimatedTotal() {
      var total = subtotal + (shippingSatang || 0) - rewardSatang - couponSatang;
      return total < 0 ? 0 : total;
    }

    function setTotal() {
      var total = estimatedTotal();
      totalEl.textContent = money(total);
      if (rewardPoints > 0) {
        /* A points discount the backend has not confirmed yet: say so, and
           keep the estimate off the pay button. */
        if (totalLabel) totalLabel.textContent = strings.totalEstimate || strings.total || '';
        payLabel.textContent = strings.pay || 'Pay';
      } else {
        if (totalLabel) totalLabel.textContent = strings.total || '';
        payLabel.textContent = (strings.pay || 'Pay') + ' ' + money(total);
      }
    }

    /* The order changed after the backend confirmed a total: that figure (and
       its payment link) no longer describes what the next press would buy. */
    function unconfirm() {
      if (!confirmedUrl) return;
      confirmedUrl = null;
      note.textContent = '';
      setTotal();
    }

    function showConfirmed(charged) {
      totalEl.textContent = money(charged);
      if (totalLabel) totalLabel.textContent = strings.total || '';
    }

    function val(name) {
      var el = form.elements[name];
      return el ? el.value.trim() : '';
    }

    /* The payment service's own quote — the SAME function that will charge the
       order (backend: _shipping_rates).

       This used to ask Shopify directly, /cart/shipping_rates.json, which reads
       the store's delivery profile. Since the backend started pricing delivery
       from the carriers' tables the profile is only its fallback, so the page
       would have displayed the profile's figure and the shopper would have been
       charged a different one at the payment link. Shipping is the one number
       on a checkout nobody may be surprised by, so both come from one place.

       Derived from service_url rather than configured separately: two settings
       could point at two backends and the estimate would drift from the charge
       with nothing on screen to show it. No service URL now means no estimate
       either — the pay button was already disabled in that case. */
    var ratesUrl = serviceUrl
      ? serviceUrl.replace(/\/+$/, '').replace(/\/checkout$/, '') + '/shipping/rates'
      : '';

    function fetchShipping() {
      var c = country.value, zip = val('zip'), province = provinceValue();
      if (!c || !zip) { shippingSatang = null; shipEl.textContent = strings.enterAddress || ''; setTotal(); gate(); return; }
      if (!ratesUrl || !cartItems.length) {
        shippingSatang = null; shipEl.textContent = strings.noShipping || '—';
        setTotal(); gate(); return;
      }

      shipEl.textContent = strings.calculating || '…';
      var token = ++reqToken;
      fetch(ratesUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: cartItems,
          address: { country: c, province: province, zip: zip,
                     city: val('city'), address1: val('address1') }
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (token !== reqToken) return;   /* a newer request superseded this */
          var rates = (res.ok && res.data && res.data.rates) || [];
          if (!rates.length) {
            /* No carrier covers this parcel and address. Leaving shippingSatang
               null keeps the pay button disabled, which is the point: there is
               no price to agree to. */
            shippingSatang = null; shippingName = '';
            shipEl.textContent = strings.noShipping || '—';
          } else {
            /* cheapest first from the backend, but sort anyway — the order the
               shopper is charged is min(), and this must match it */
            rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
            shippingSatang = Math.round(parseFloat(rates[0].price) * 100);
            shippingName = rates[0].title;
            shipEl.textContent = money(shippingSatang) + (shippingName ? ' · ' + shippingName : '');
          }
          setTotal(); gate();
        })
        .catch(function () {
          if (token !== reqToken) return;
          shippingSatang = null; shipEl.textContent = strings.shipError || '—';
          setTotal(); gate();
        });
    }
    var reqToken = 0;

    /* Shape, not just presence. type="tel" and inputmode only choose the
       keyboard — they refuse nothing — so a phone of Thai letters or a
       3-digit postcode passed the old check, reached the carrier lookup, got
       no rate back, and the shopper saw a dead Pay button with no reason on
       screen (measured live 2026-10-16). */
    function phoneOk() { return val('phone').replace(/\D/g, '').length >= 9; }
    function emailOk() { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('email')); }
    function zipOk() {
      var z = val('zip');
      return country.value === 'Thailand' ? /^\d{5}$/.test(z) : /^[A-Za-z0-9\- ]{3,10}$/.test(z);
    }
    function formFilled() {
      var required = ['first_name', 'last_name', 'email', 'phone', 'address1', 'city', 'zip'];
      for (var i = 0; i < required.length; i++) if (!val(required[i])) return false;
      return !!provinceValue();
    }
    function formComplete() { return formFilled() && phoneOk() && emailOk() && zipOk(); }

    function gate() {
      var ready = formComplete() && shippingSatang !== null && serviceUrl;
      payBtn.disabled = !ready;
      if (!serviceUrl) {
        note.textContent = strings.serviceComing || '';
      } else if (formFilled() && !formComplete()) {
        /* Everything is typed and the button is still off: say which field. */
        note.textContent = !phoneOk() ? (strings.checkPhone || '')
                         : !emailOk() ? (strings.checkEmail || '')
                         : (strings.checkZip || '');
      } else if (!ready) {
        note.textContent = '';
      }
    }

    /* debounce shipping calls while typing the zip */
    var t;
    form.addEventListener('input', function (e) {
      /* Strip what the field cannot mean as it is typed: letters in a phone
         number, anything but five digits in a Thai postcode. */
      if (e.target.name === 'phone') e.target.value = e.target.value.replace(/[^0-9+()\-\s]/g, '');
      if (e.target.name === 'zip' && country.value === 'Thailand') e.target.value = e.target.value.replace(/\D/g, '').slice(0, 5);
      unconfirm();
      gate();
      if (e.target.name === 'zip' || e.target.name === 'province' || e.target.name === 'province_other') {
        clearTimeout(t); t = setTimeout(fetchShipping, 400);
      }
    });
    country.addEventListener('change', function () { unconfirm(); syncProvince(); fetchShipping(); });

    payBtn.addEventListener('click', function () {
      if (payBtn.disabled) return;
      if (confirmedUrl) {
        /* The customer has seen the confirmed total on this button: go and pay it. */
        payBtn.disabled = true;
        note.textContent = strings.redirecting || '…';
        window.location.href = confirmedUrl;
        return;
      }
      payBtn.disabled = true;
      note.textContent = strings.redirecting || '…';
      var estimate = estimatedTotal();
      var payload = {
        items: cartItems,
        address: {
          firstName: val('first_name'), lastName: val('last_name'),
          email: val('email'), phone: val('phone'),
          address1: val('address1'), city: val('city'),
          province: provinceValue(), zip: val('zip'), country: country.value
        },
        shipping: { amount: shippingSatang, name: shippingName },
        /* a REQUEST: the backend spends min(this, the live balance, the cap) */
        reward: { points: rewardPoints, amount: rewardSatang },
        coupon: { code: couponCode },
        currency: root.getAttribute('data-currency') || 'THB'
      };
      fetch(serviceUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          /* Keep the status: a 400 is something the SHOPPER can act on (an
             unpriced or unsellable line, an address the carrier refused) and
             the backend names it in `detail`. Swallowing that into the generic
             message leaves them pressing Pay forever with nothing to go on.
             A 5xx is ours, and "try again" is genuinely all they can do. */
          return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; });
        })
        .then(function (res) {
          var data = res.data;
          if (res.status === 422 && data && data.error === 'coupon') {
            /* The backend refused the code and created nothing. */
            rejectCoupon(data.reason);
            note.textContent = '';
            payBtn.disabled = false;
            return;
          }
          if (!res.ok) {
            var detail = data && typeof data.detail === 'string' ? data.detail : '';
            note.textContent = (res.status < 500 && detail) ? detail : (strings.payError || '—');
            payBtn.disabled = false;
            return;
          }
          var charged = data ? parseInt(data.amountSatang, 10) : NaN;
          if (!data || !data.url || isNaN(charged)) {
            note.textContent = strings.payError || '—'; payBtn.disabled = false;
            return;
          }
          /* From here on the page shows the backend's figure, never its own. */
          if (couponCode && data.discounts && !isNaN(parseInt(data.discounts.couponSatang, 10))) {
            couponSatang = parseInt(data.discounts.couponSatang, 10);
            renderCoupon();
          }
          showConfirmed(charged);
          if (charged === estimate) {
            payLabel.textContent = (strings.pay || 'Pay') + ' ' + money(charged);
            note.textContent = fill(strings.charging, 'amount', money(charged));
            window.location.href = data.url;
          } else {
            /* Not the figure the customer was looking at (points capped by the
               live balance, a hold from another tab, a shipping change): show
               it and let them press again rather than send them to pay it. */
            confirmedUrl = data.url;
            payLabel.textContent = (strings.continuePay || strings.pay || 'Pay') + ' ' + money(charged);
            note.textContent = fill(strings.adjusted, 'amount', money(charged));
            payBtn.disabled = false;
          }
        })
        .catch(function () { note.textContent = strings.payError || '—'; payBtn.disabled = false; });
    });

    /* ---- reward points: the signed-in customer's REAL balance ----
       Liquid renders the card only for a signed-in customer, hidden. It is shown
       only when /reward/balance says loyalty is `enabled` and there is something
       to spend under the cap. The cap is the backend's `maxRedeemPct` of the
       goods (cart subtotal), and the most on offer is min(spendable, cap) —
       both from the backend, never a percentage hard-coded here. What the
       customer picks is sent as a REQUEST; /checkout recomputes the discount
       and its amountSatang is the confirmed total (above). 1 pt = ฿1.
       `staged` is what the slider/chips show; `rewardSatang`/`rewardPoints`
       only change on "Apply to order". */
    (function reward() {
      var card = root.querySelector('[data-reward]');
      if (!card) return;
      var endpoint = (card.getAttribute('data-endpoint') || '').trim();
      if (!endpoint) return;
      var slider = card.querySelector('[data-reward-slider]');
      var applyBtn = card.querySelector('[data-reward-apply]');
      var applyingEl = card.querySelector('[data-reward-applying]');
      var applyingSub = card.querySelector('[data-reward-applying-sub]');
      var capLabel = card.querySelector('[data-reward-cap-label]');
      var maxTick = card.querySelector('[data-reward-max-tick]');
      var spendableEl = card.querySelector('[data-reward-spendable]');
      var availableEl = card.querySelector('[data-reward-available]');
      var noteEl = card.querySelector('[data-reward-note]');
      var line = root.querySelector('[data-reward-line]');
      var linePts = root.querySelector('[data-reward-line-pts]');
      var lineAmount = root.querySelector('[data-reward-line-amount]');
      var rewStrings = (window.AXIS_STRINGS && window.AXIS_STRINGS.reward) || {};
      var maxPoints = 0;
      var staged = 0;

      function fmtPts(n) {
        return fill(rewStrings.points || '{{ n }} points', 'n', n.toLocaleString('en-US'));
      }
      function setStaged(n) {
        staged = Math.max(0, Math.min(maxPoints, n));
        slider.value = staged;
        applyingEl.textContent = staged.toLocaleString('en-US');
        applyingSub.textContent = fmtPts(staged);
        Array.prototype.forEach.call(card.querySelectorAll('[data-reward-set]'), function (b) {
          var v = b.getAttribute('data-reward-set');
          var pts = v === 'max' ? maxPoints : parseInt(v, 10);
          b.classList.toggle('is-active', pts === staged);
          b.disabled = pts > maxPoints && v !== 'max';
        });
      }

      function show(spendable, pct) {
        /* the cap, in whole points: floor(goods baht × pct / 100) — the backend's formula */
        var capPoints = Math.floor(subtotal * pct / 10000);
        maxPoints = Math.min(spendable, capPoints);
        if (maxPoints <= 0) return;                 /* nothing to spend on this cart: no card */
        spendableEl.textContent = spendable.toLocaleString('en-US');
        if (availableEl) availableEl.textContent = fill(rewStrings.available, 'max', maxPoints.toLocaleString('en-US'));
        if (capLabel) capLabel.textContent = (rewStrings.useUpTo || 'up to') + ' ' + money(maxPoints * 100);
        if (maxTick) maxTick.textContent = maxPoints.toLocaleString('en-US') + ' pt';
        if (noteEl) noteEl.textContent = fill(rewStrings.note, 'pct', String(pct));
        slider.max = maxPoints;
        setStaged(0);
        card.hidden = false;
      }

      slider.addEventListener('input', function () { setStaged(parseInt(slider.value, 10) || 0); });
      Array.prototype.forEach.call(card.querySelectorAll('[data-reward-set]'), function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-reward-set');
          setStaged(v === 'max' ? maxPoints : parseInt(v, 10));
        });
      });

      applyBtn.addEventListener('click', function () {
        rewardPoints = staged;
        rewardSatang = staged * 100;          /* 1 pt = ฿1 — an estimate until /checkout confirms */
        if (rewardPoints > 0) {
          line.hidden = false;
          linePts.textContent = rewardPoints.toLocaleString('en-US');
          lineAmount.textContent = '−' + money(rewardSatang);
        } else {
          line.hidden = true;
        }
        confirmedUrl = null;
        note.textContent = '';
        setTotal();
      });

      fetch(endpoint, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (d) {
          /* Loyalty off, or a response without the contract's fields: no card,
             never a confident zero. Checkout simply proceeds at full price. */
          if (!d || d.enabled !== true) return;
          var spendable = parseInt(d.spendable, 10);
          var pct = parseInt(d.maxRedeemPct, 10);
          if (!(spendable > 0) || !(pct > 0)) return;
          show(spendable, pct);
        })
        .catch(function () { /* balance unreadable: no card, full price */ });
    }());

    /* ---- coupon code ----
       The backend owns validation. /coupon/check previews the discount for the
       current items; the applied code rides along in the /checkout payload and
       /checkout re-validates it (a 422 `coupon` un-applies it, see the pay
       handler). couponSatang is only an estimate until /checkout answers.
       Function declarations are hoisted so the pay handler can call
       rejectCoupon/renderCoupon. */
    var couponEl = root.querySelector('[data-coupon]');
    var couponUrl = serviceUrl
      ? serviceUrl.replace(/\/+$/, '').replace(/\/checkout$/, '') + '/coupon/check'
      : '';
    var couponToken = 0;

    function couponStr(key) {
      return (window.AXIS_STRINGS && window.AXIS_STRINGS.beam && window.AXIS_STRINGS.beam[key]) || '';
    }
    function couponReasonText(reason) {
      var map = { not_found: 'couponReasonNotFound', inactive: 'couponReasonInactive',
        not_started: 'couponReasonNotStarted', expired: 'couponReasonExpired',
        min_subtotal: 'couponReasonMinSubtotal', min_qty: 'couponReasonMinQty',
        usage_limit: 'couponReasonUsageLimit', once_per_customer: 'couponReasonOncePerCustomer',
        unsupported: 'couponReasonUnsupported', login_required: 'couponReasonLoginRequired' };
      return couponStr(map[reason]) || couponStr('couponError');
    }
    function couponMsg(text) {
      var el = couponEl.querySelector('[data-coupon-msg]');
      el.textContent = text || '';
      el.hidden = !text;
    }
    /* Draw the card, the summary line and the total from couponCode/couponSatang. */
    function renderCoupon() {
      if (!couponEl) return;
      var applied = !!couponCode;
      var amount = money(couponSatang);
      couponEl.querySelector('[data-coupon-form]').hidden = applied;
      couponEl.querySelector('[data-coupon-applied]').hidden = !applied;
      couponEl.querySelector('[data-coupon-applied-text]').textContent =
        fill(fill(couponStr('couponApplied'), 'code', couponCode), 'amount', amount);
      var line = root.querySelector('[data-coupon-line]');
      line.hidden = !applied;
      root.querySelector('[data-coupon-line-label]').textContent = fill(couponStr('couponLine'), 'code', couponCode);
      root.querySelector('[data-coupon-line-amount]').textContent = '−' + amount;
      setTotal();
    }
    function clearCoupon() {
      couponCode = ''; couponSatang = 0;
      renderCoupon();
    }
    function rejectCoupon(reason) {
      clearCoupon();
      couponMsg(couponReasonText(reason));
    }
    function applyCoupon() {
      var input = couponEl.querySelector('[data-coupon-input]');
      var btn = couponEl.querySelector('[data-coupon-apply]');
      var code = input.value.replace(/\s+/g, '').toUpperCase();
      input.value = code;
      if (!code) return;
      if (!couponUrl || !cartItems.length) { couponMsg(couponStr('couponError')); return; }
      var token = ++couponToken;
      btn.disabled = true; couponMsg('');
      fetch(couponUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: code, items: cartItems })
      })
        .then(function (r) { return r.json().then(function (d) { return { status: r.status, data: d }; }); })
        .then(function (res) {
          if (token !== couponToken) return;
          var d = res.data;
          if (res.status === 429) { couponMsg(couponStr('couponRateLimited')); return; }
          if (res.status !== 200 || !d) { couponMsg(couponStr('couponError')); return; }
          if (d.ok === true && !isNaN(parseInt(d.amountSatang, 10))) {
            couponCode = d.code || code;
            couponSatang = parseInt(d.amountSatang, 10);
            unconfirm();
            renderCoupon();
            gate();
          } else {
            rejectCoupon(d.reason);
          }
        })
        .catch(function () { if (token === couponToken) couponMsg(couponStr('couponError')); })
        .then(function () { btn.disabled = false; });
    }
    if (couponEl) {
      couponEl.querySelector('[data-coupon-form]').addEventListener('submit', function (e) {
        e.preventDefault(); applyCoupon();
      });
      couponEl.querySelector('[data-coupon-input]').addEventListener('input', function (e) {
        e.target.value = e.target.value.replace(/\s+/g, '').toUpperCase();
        couponMsg('');
      });
      couponEl.querySelector('[data-coupon-remove]').addEventListener('click', function () {
        couponToken++;
        unconfirm(); clearCoupon(); couponMsg('');
        couponEl.querySelector('[data-coupon-input]').value = '';
      });
    }

    setTotal(); gate();
  }());

  /* ---------- PDP Buy now (add + go to cart, not an express provider) ---------- */
  (function buyNow() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-buy-now]'), function (btn) {
      btn.addEventListener('click', function () {
        var form = btn.closest('form.product-form');
        if (!form) return;
        btn.disabled = true;
        fetch('/cart/add.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add'); })
          .then(function () { window.location.href = btn.getAttribute('data-buy-now') || '/cart'; })
          .catch(function () { btn.disabled = false; });
      });
    });
  }());

  /* ---------- Rewards balance (main-rewards.liquid) ----------
     Real balance from the loyalty backend, fetched through the App Proxy path in
     `data-endpoint` (a section setting — merchants can blank it to kill the
     feature without a code change; the section then never renders this block).
     Only rendered by Liquid when `customer` exists, so there is no signed-out
     fetch to 401 on. Hidden until the response says loyalty is `enabled`.

     `spendable` (max(0, balance - held), never negative) is the headline number.
     `balance` itself can be negative — a redeemed order that was later refunded
     drives the customer below zero until they earn it back — so the note spells
     that out rather than the widget showing a cheerful zero the customer cannot
     reconcile with their order history. A non-2xx response (503: balance could
     not be read; nothing else is expected here) shows "balance unavailable",
     never a confident number. */
  (function rewardsBalance() {
    var blocks = [].slice.call(document.querySelectorAll('[data-reward-balance]'));
    if (!blocks.length) return;
    /* Every block on the page shows the same customer's points, so one fetch
       feeds all of them. Two blocks fetching separately could render two
       different answers from two moments. */
    var endpoint = (blocks[0].getAttribute('data-endpoint') || '').trim();
    if (!endpoint) return;

    var strings = (window.AXIS_STRINGS && window.AXIS_STRINGS.rewardsBalance) || {};
    var tiers = (window.AXIS_STRINGS && window.AXIS_STRINGS.tiers) || {};

    function num(v) { return (v || 0).toLocaleString('en-US'); }
    function fill(str, vars) {
      return (str || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
        return Object.prototype.hasOwnProperty.call(vars, key) ? vars[key] : m;
      });
    }

    /* Which tier `earned` falls in: the highest entry point it reaches.
       Returns -1 when the tiers are not configured or earned is below the
       first entry point — the caller then shows no tier at all rather than
       guessing one. */
    function tierIndex(earned, cuts) {
      var found = -1;
      for (var i = 0; i < cuts.length; i++) {
        if (earned >= cuts[i]) found = i;
      }
      return found;
    }

    function paintTier(block, earned) {
      var box = block.querySelector('[data-reward-tier]');
      if (!box) return;
      var names = tiers.names || [];
      var cuts = tiers.thresholds || [];
      /* No tier when the backend did not send `earned` (a theme deployed
         ahead of the backend), or when the tiers are not configured. Hiding
         is the honest outcome: a tier is a claim about standing. */
      if (typeof earned !== 'number' || !names.length || !cuts.length) {
        box.hidden = true;
        return;
      }
      var i = tierIndex(earned, cuts);
      if (i < 0 || !names[i]) { box.hidden = true; return; }

      var nameEl = box.querySelector('[data-reward-tier-name]');
      var barEl = box.querySelector('[data-reward-tier-bar]');
      var noteEl = box.querySelector('[data-reward-tier-note]');
      var earnedEl = box.querySelector('[data-reward-tier-earned]');
      if (nameEl) nameEl.textContent = names[i];

      var isTop = (i >= cuts.length - 1) || (i >= names.length - 1);
      if (isTop) {
        if (barEl) barEl.style.width = '100%';
        if (noteEl) noteEl.textContent = tiers.max || '';
      } else {
        var from = cuts[i];
        var to = cuts[i + 1];
        var span = to - from;
        var pct = span > 0 ? ((earned - from) / span) * 100 : 0;
        if (pct < 0) pct = 0;
        if (pct > 100) pct = 100;
        if (barEl) barEl.style.width = pct.toFixed(1) + '%';
        if (noteEl) {
          noteEl.textContent = fill(tiers.progress, { n: num(to - earned), next: names[i + 1] });
        }
      }
      if (earnedEl) earnedEl.textContent = fill(tiers.earned, { n: num(earned) });
      box.hidden = false;
    }

    /* The block is rendered `hidden` and only revealed with something true to
       say: a balance when the backend says loyalty is `enabled`, or "balance
       unavailable" when it could not be read. With loyalty switched off
       (`enabled: false`) it stays hidden — never a confident "0" for a
       feature that is not on. The redeem cap in the note is the backend's
       `maxRedeemPct`, never a percentage copied into this theme. */
    fetch(endpoint, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function (d) {
        blocks.forEach(function (el) {
          var n = el.querySelector('[data-reward-points]');
          var note = el.querySelector('[data-reward-note]');
          if (!n || !note) return;
          if (!d || d.enabled !== true) { el.hidden = true; return; }
          var balance = parseInt(d.balance, 10) || 0;
          var held = parseInt(d.held, 10) || 0;
          var spendable = parseInt(d.spendable, 10) || 0;
          var pct = parseInt(d.maxRedeemPct, 10) || 0;
          n.textContent = num(spendable);
          n.classList.toggle('rw-balance__n--neg', balance < 0);
          if (balance < 0) {
            note.textContent = fill(strings.negative, { n: num(balance) });
          } else if (held > 0) {
            note.textContent = fill(strings.held, { n: num(held) });
          } else {
            note.textContent = fill(strings.ok, { pct: String(pct) });
          }
          /* `earned` is standing, `spendable` is money — never derived from
             one another. An older backend omits it and the tier stays hidden. */
          paintTier(el, typeof d.earned === 'number' ? d.earned : null);
          el.hidden = false;
        });
      })
      .catch(function () {
        blocks.forEach(function (el) {
          var n = el.querySelector('[data-reward-points]');
          var note = el.querySelector('[data-reward-note]');
          var box = el.querySelector('[data-reward-tier]');
          if (n) n.textContent = '—';
          if (note) note.textContent = strings.error || '';
          if (box) box.hidden = true;
          el.hidden = false;
        });
      });
  }());

/* ==== tegiwa layout: mega menu · drawer drill-down · country popover ==== */
/* Appended 2026-10-30 for the tegiwa-structure header/footer. Separate IIFE so
   it cannot interfere with the blocks above; every control degrades to a plain
   link/form submit without it. */
(function tegiwaChrome() {
  'use strict';

  /* ---------- mega menu (hover on pointer devices, click/tap toggles, keyboard) ---------- */
  (function megaMenu() {
    var items = document.querySelectorAll('[data-mega]');
    if (!items.length) return;
    var hoverMq = window.matchMedia('(hover: hover) and (min-width: 1024px)');
    var openItem = null;

    function setOpen(item, on) {
      var toggle = item.querySelector('[data-mega-toggle]');
      var panel = item.querySelector('[data-mega-panel]');
      if (!toggle || !panel) return;
      item.classList.toggle('is-open', on);
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      panel.hidden = !on;
      if (on) {
        if (openItem && openItem !== item) setOpen(openItem, false);
        openItem = item;
      } else if (openItem === item) {
        openItem = null;
      }
    }

    Array.prototype.forEach.call(items, function (item) {
      var toggle = item.querySelector('[data-mega-toggle]');
      var panel = item.querySelector('[data-mega-panel]');
      if (!toggle || !panel) return;
      var leaveTimer = null;

      toggle.addEventListener('click', function (e) {
        e.preventDefault();
        setOpen(item, panel.hidden);
      });

      /* hover only where a hover exists — a tap on touch must not open-then-navigate */
      item.addEventListener('mouseenter', function () {
        if (!hoverMq.matches) return;
        window.clearTimeout(leaveTimer);
        setOpen(item, true);
      });
      item.addEventListener('mouseleave', function () {
        if (!hoverMq.matches) return;
        leaveTimer = window.setTimeout(function () { setOpen(item, false); }, 140);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hidden) {
          e.preventDefault();
          setOpen(item, false);
          toggle.focus();
        }
      });

      /* tabbing out of the panel closes it */
      item.addEventListener('focusout', function (e) {
        if (!e.relatedTarget || item.contains(e.relatedTarget)) return;
        setOpen(item, false);
      });
    });

    document.addEventListener('click', function (e) {
      if (openItem && !openItem.contains(e.target)) setOpen(openItem, false);
    });
    /* Escape closes a hover-opened panel too (focus may still be on the body) */
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !openItem) return;
      var t = openItem.querySelector('[data-mega-toggle]');
      setOpen(openItem, false);
      if (t) t.focus();
    });
  }());

  /* ---------- mobile drawer: drill-down panels ---------- */
  (function drawerPanels() {
    var root = document.querySelector('[data-drawer-panels]');
    if (!root) return;
    var panels = root.querySelectorAll('[data-drawer-panel]');
    var drawer = root.closest('[data-drawer]');

    function panelById(id) {
      return root.querySelector('[data-drawer-panel="' + id + '"]');
    }

    function show(id, focusSel) {
      var target = panelById(id);
      if (!target) return;
      Array.prototype.forEach.call(panels, function (p) {
        var on = p === target;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
      });
      if (drawer) drawer.scrollTop = 0;
      var f = focusSel ? target.querySelector(focusSel) : null;
      if (f) f.focus();
    }

    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-drawer-go]');
      if (go) {
        e.preventDefault();
        go.setAttribute('aria-expanded', 'true');
        show(go.getAttribute('data-drawer-go'), '[data-drawer-back]');
        return;
      }
      var back = e.target.closest('[data-drawer-back]');
      if (back) {
        e.preventDefault();
        var to = back.getAttribute('data-drawer-back');
        var from = back.closest('[data-drawer-panel]');
        var fromId = from ? from.getAttribute('data-drawer-panel') : '';
        show(to);
        var opener = panelById(to) && panelById(to).querySelector('[data-drawer-go="' + fromId + '"]');
        if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
      }
    });

    /* every open starts at the top level */
    Array.prototype.forEach.call(document.querySelectorAll('[data-drawer-open]'), function (b) {
      b.addEventListener('click', function () {
        Array.prototype.forEach.call(root.querySelectorAll('[data-drawer-go]'), function (g) { g.setAttribute('aria-expanded', 'false'); });
        show('root');
      });
    });
  }());

  /* ---------- country popover (<details>): close on outside click / Escape ---------- */
  (function countryMenu() {
    var menus = document.querySelectorAll('[data-country-menu]');
    if (!menus.length) return;
    function closeAll(except) {
      Array.prototype.forEach.call(menus, function (m) { if (m !== except && m.open) m.open = false; });
    }
    document.addEventListener('click', function (e) {
      var inside = e.target.closest('[data-country-menu]');
      closeAll(inside);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      Array.prototype.forEach.call(menus, function (m) {
        if (m.open) { m.open = false; var s = m.querySelector('summary'); if (s) s.focus(); }
      });
    });
  }());

  /* ---------- localization <select>s submit on change (Apply button is the no-JS path) ---------- */
  (function localizationSelects() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-localization-select]'), function (sel) {
      sel.addEventListener('change', function () {
        var form = sel.closest('form');
        if (form) form.submit();
      });
    });
  }());
}());

  /* ============================================================
     tegiwa layout: pages — hero slider, product carousels, build list
     (localStorage), recently viewed, PDP gallery zoom / qty / share /
     description expander / price-match. Progressive enhancement: every
     control here degrades to a plain link or form.
     ============================================================ */
  (function tegiwaPages() {
    'use strict';
    var WISH = 'axis_wishlist';
    var RECENT = 'axis_recent';

    function esc(s) {
      return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }
    function readList(key) {
      try { var v = JSON.parse(window.localStorage.getItem(key) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
    }
    function writeList(key, list) {
      try { window.localStorage.setItem(key, JSON.stringify(list)); } catch (e) { /* private mode: nothing to keep */ }
    }
    function parseJsonAttr(el, name) {
      try { return JSON.parse(el.getAttribute(name) || ''); } catch (e) { return null; }
    }
    function cardHtml(p, removeLabel) {
      var url = encodeURI(p.url || '#');
      return '<div class="pcard" data-handle="' + esc(p.handle) + '"><div class="pcard__media">' +
        '<a class="pcard__img ph" href="' + url + '" aria-label="' + esc(p.title) + '">' +
        (p.image ? '<img src="' + encodeURI(p.image) + '" alt="" width="400" height="400" loading="lazy">' : '<span class="ph-label">' + esc(p.vendor) + '</span>') +
        '</a>' +
        (removeLabel ? '<button type="button" class="pcard__wish pcard__wish--remove is-on" data-wish-remove="' + esc(p.handle) + '" aria-label="' + esc(removeLabel) + '">&times;</button>' : '') +
        '</div><div class="pcard__body"><div class="pcard__meta"><span class="mono">' + esc(p.vendor) + '</span></div>' +
        '<a class="pcard__name" href="' + url + '">' + esc(p.title) + '</a>' +
        '<div class="pcard__foot"><div class="pcard__price"><span class="now">' + esc(p.price) + '</span></div></div></div></div>';
    }
    function renderCards(grid, items, removeLabel) {
      grid.innerHTML = items.map(function (p) { return cardHtml(p, removeLabel); }).join('');
    }

    /* ---- Build list (wishlist) ---- */
    function inWish(handle) {
      return readList(WISH).some(function (x) { return x.handle === handle; });
    }
    function addWish(p) {
      var l = readList(WISH).filter(function (x) { return x.handle !== p.handle; });
      l.unshift(p);
      writeList(WISH, l.slice(0, 100));
    }
    function removeWish(handle) {
      writeList(WISH, readList(WISH).filter(function (x) { return x.handle !== handle; }));
    }
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-toggle]'), function (btn) {
      var p = parseJsonAttr(btn, 'data-wish');
      if (!p || !p.handle) return;
      if (inWish(p.handle)) btn.classList.add('is-on');
      btn.addEventListener('click', function () {
        if (inWish(p.handle)) { removeWish(p.handle); btn.classList.remove('is-on'); }
        else { addWish(p); btn.classList.add('is-on'); }
      });
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-wishlist-add]'), function (btn) {
      var p = parseJsonAttr(btn, 'data-wish');
      if (!p || !p.handle) return;
      var url = btn.getAttribute('data-wishlist-url');
      var added = btn.getAttribute('data-label-added');
      function mark() {
        btn.classList.add('is-added');
        btn.setAttribute('data-added', '1');
        if (added) btn.textContent = added;
      }
      if (inWish(p.handle)) mark();
      btn.addEventListener('click', function () {
        if (btn.getAttribute('data-added')) { if (url) window.location.href = url; return; }
        addWish(p);
        mark();
      });
    });
    var wishPage = document.querySelector('[data-wishlist-page]');
    if (wishPage) {
      var wGrid = wishPage.querySelector('[data-wishlist-grid]');
      var wEmpty = wishPage.querySelector('[data-wishlist-empty]');
      var paintWish = function () {
        var l = readList(WISH);
        if (!wGrid || !wEmpty) return;
        if (!l.length) { wGrid.hidden = true; wEmpty.hidden = false; return; }
        wGrid.hidden = false; wEmpty.hidden = true;
        renderCards(wGrid, l, wGrid.getAttribute('data-remove-label') || 'Remove');
      };
      paintWish();
      if (wGrid) wGrid.addEventListener('click', function (e) {
        var b = e.target.closest('[data-wish-remove]');
        if (!b) return;
        removeWish(b.getAttribute('data-wish-remove'));
        paintWish();
      });
    }

    /* ---- Recently viewed ---- */
    var pdp = document.querySelector('[data-pdp]');
    var current = pdp ? parseJsonAttr(pdp, 'data-product') : null;
    Array.prototype.forEach.call(document.querySelectorAll('[data-recently-viewed]'), function (sec) {
      var ex = sec.getAttribute('data-exclude');
      var grid = sec.querySelector('[data-recently-viewed-grid]');
      var l = readList(RECENT).filter(function (x) { return x.handle && x.handle !== ex; }).slice(0, 8);
      if (!l.length || !grid) return;
      renderCards(grid, l);
      sec.hidden = false;
    });
    if (current && current.handle) {
      var rl = readList(RECENT).filter(function (x) { return x.handle !== current.handle; });
      rl.unshift(current);
      writeList(RECENT, rl.slice(0, 12));
    }

    /* ---- Hero slider ---- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-hslider]'), function (root) {
      var slides = root.querySelectorAll('.hslide');
      if (slides.length < 2) return;
      var dots = root.querySelectorAll('[data-hslider-dot]');
      var prev = root.querySelector('[data-hslider-prev]');
      var next = root.querySelector('[data-hslider-next]');
      var auto = root.getAttribute('data-autoplay') === 'true';
      var every = parseInt(root.getAttribute('data-interval'), 10) || 6000;
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var i = 0, timer = null;
      function go(n) {
        i = (n + slides.length) % slides.length;
        Array.prototype.forEach.call(slides, function (s, k) { s.classList.toggle('is-active', k === i); });
        Array.prototype.forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
      }
      function stop() { if (timer) window.clearInterval(timer); timer = null; }
      function start() { if (!auto || reduce) return; stop(); timer = window.setInterval(function () { go(i + 1); }, every); }
      if (prev) prev.addEventListener('click', function () { go(i - 1); start(); });
      if (next) next.addEventListener('click', function () { go(i + 1); start(); });
      Array.prototype.forEach.call(dots, function (d) {
        d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-hslider-dot'), 10) || 0); start(); });
      });
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      start();
    });

    /* ---- Product carousels: "1 / N" pager + arrows over a scroll-snap track ---- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-pcarousel]'), function (root) {
      var track = root.querySelector('[data-pcarousel-track]');
      var pager = root.querySelector('[data-pcarousel-pager]');
      var prev = root.querySelector('[data-pcarousel-prev]');
      var next = root.querySelector('[data-pcarousel-next]');
      if (!track || !track.children.length) return;
      function step() {
        var first = track.children[0];
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 0;
        var w = first.getBoundingClientRect().width + gap;
        var per = Math.max(1, Math.round((track.clientWidth + gap) / w));
        return { px: per * w, pages: Math.max(1, Math.ceil(track.children.length / per)) };
      }
      function page() { var s = step(); return Math.min(s.pages - 1, Math.round(track.scrollLeft / s.px)); }
      function update() {
        var s = step(), p = page();
        if (pager) pager.textContent = (p + 1) + ' / ' + s.pages;
        if (prev) prev.disabled = p <= 0;
        if (next) next.disabled = p >= s.pages - 1;
      }
      function goTo(p) {
        var s = step();
        p = Math.max(0, Math.min(s.pages - 1, p));
        track.scrollTo({ left: p * s.px, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { goTo(page() - 1); });
      if (next) next.addEventListener('click', function () { goTo(page() + 1); });
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = null; update(); });
      });
      window.addEventListener('resize', update);
      update();
    });

    /* ---- PDP: thumbnails + hover zoom ---- */
    var main = document.querySelector('[data-zoom]');
    if (main) {
      var img = main.querySelector('[data-zoom-img]');
      var pane = main.querySelector('[data-zoom-pane]');
      var locked = false;
      function setPane() { if (pane && img) pane.style.backgroundImage = 'url("' + img.getAttribute('data-zoom-src') + '")'; }
      function place(e) {
        if (!pane) return;
        var r = main.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        pane.style.backgroundPosition = x + '% ' + y + '%';
      }
      if (img && pane) {
        setPane();
        main.addEventListener('mouseenter', function () { main.classList.add('is-zooming'); });
        main.addEventListener('mousemove', place);
        main.addEventListener('mouseleave', function () { if (!locked) main.classList.remove('is-zooming'); });
        main.addEventListener('click', function (e) {
          locked = !locked;
          main.classList.toggle('is-locked', locked);
          if (locked) place(e);
        });
      }
      Array.prototype.forEach.call(document.querySelectorAll('[data-thumb]'), function (t) {
        t.addEventListener('click', function () {
          if (!img) return;
          img.src = t.getAttribute('data-src');
          img.setAttribute('data-zoom-src', t.getAttribute('data-zoom-src'));
          setPane();
          Array.prototype.forEach.call(document.querySelectorAll('[data-thumb]'), function (o) { o.classList.toggle('is-active', o === t); });
        });
      });
    }

    /* ---- PDP: quantity stepper ---- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-qty]'), function (box) {
      var input = box.querySelector('input');
      if (!input) return;
      function set(n) { var min = parseInt(input.min, 10) || 1; input.value = Math.max(min, n); }
      var minus = box.querySelector('[data-qty-minus]');
      var plus = box.querySelector('[data-qty-plus]');
      if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
      if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    });

    /* ---- PDP: copy link ---- */
    Array.prototype.forEach.call(document.querySelectorAll('[data-copy-link]'), function (btn) {
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-copy-link') || window.location.href;
        var note = document.querySelector('[data-copy-note]');
        function done() {
          if (!note) return;
          note.textContent = btn.getAttribute('data-copied-label') || '';
          window.setTimeout(function () { note.textContent = ''; }, 2000);
        }
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
        else { window.prompt('', url); done(); }
      });
    });

    /* ---- PDP: description "View more" (collapsed at ~240px) ---- */
    var desc = document.querySelector('[data-desc]');
    var descToggle = document.querySelector('[data-desc-toggle]');
    if (desc && descToggle) {
      var inner = desc.querySelector('[data-desc-in]');
      if (inner && inner.scrollHeight > 260) {
        desc.classList.add('is-clamped');
        descToggle.hidden = false;
        descToggle.addEventListener('click', function () {
          var open = desc.classList.toggle('is-open');
          descToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          descToggle.textContent = open ? descToggle.getAttribute('data-label-less') : descToggle.getAttribute('data-label-more');
        });
      } else {
        desc.classList.remove('pdp-desc--clamp');
      }
    }

    /* ---- PDP: price match — reopen after Shopify's contact-form round trip ---- */
    var pm = document.querySelector('[data-pm]');
    if (pm && (/contact_posted=true/.test(window.location.search) || pm.querySelector('.formerr'))) {
      pm.open = true;
      pm.scrollIntoView({ block: 'center' });
    }
  }());
